// ─────────────────────────────────────────────────────────────────────────────
// Risk Unit helpers — strategy-level unit that governs how the WATCHLIST risk
// template (Target/SL) is interpreted/displayed. It does NOT apply to Open
// Positions, which always hold actual numeric price levels.
//
// Canonical values mirror the backend: PERCENT | POINTS | ABSOLUTE (default PERCENT).
// ─────────────────────────────────────────────────────────────────────────────

export const RISK_UNIT_OPTIONS = [
  { value: 'PERCENT', label: 'Percent' },
  { value: 'POINTS', label: 'Points' },
  { value: 'ABSOLUTE', label: 'Absolute' },
];

const RISK_UNIT_ALIASES = {
  PERCENT: 'PERCENT', PCT: 'PERCENT', '%': 'PERCENT',
  POINTS: 'POINTS', PTS: 'POINTS', PT: 'POINTS',
  ABSOLUTE: 'ABSOLUTE', ABS: 'ABSOLUTE',
};

// Coerce any backend/legacy value to a canonical unit; missing/unknown → PERCENT.
export function normalizeRiskUnit(value) {
  return RISK_UNIT_ALIASES[String(value ?? '').trim().toUpperCase()] || 'PERCENT';
}

// Human label for modal/header display.
export function riskUnitLabel(unit) {
  const u = normalizeRiskUnit(unit);
  return u === 'PERCENT' ? 'Percent' : u === 'POINTS' ? 'Points' : 'Absolute';
}

export function unitShort(unit) {
  const u = normalizeRiskUnit(unit);
  return u === 'PERCENT' ? '%' : u === 'POINTS' ? 'pts' : 'Price';
}

// Column header label: "Target (%)", "SL (pts)", "Target Price" / "SL Price".
export function riskColumnLabel(base, unit) {
  const u = normalizeRiskUnit(unit);
  if (u === 'ABSOLUTE') return `${base} Price`;
  return `${base} (${u === 'PERCENT' ? '%' : 'pts'})`;
}

// Value + unit for modal / header display: "20%" / "20 pts" / "20" (absolute price).
// Empty/null → "—".
export function formatRiskWithUnit(value, unit) {
  if (value == null || value === '') return '—';
  const u = normalizeRiskUnit(unit);
  if (u === 'PERCENT') return `${value}%`;
  if (u === 'POINTS') return `${value} pts`;
  return `${value}`;
}
